import isEmpty from 'lodash/isEmpty';

import { isFeatureEnabled } from '@lumapps/features';
import { mdiHeart, mdiHeartOutline, mdiThumbUp, mdiThumbUpOutline } from '@lumapps/lumx/icons';
import type { ReactionState } from '@lumapps/reactions-core/api/types';
import { useSelector } from '@lumapps/redux/react';

export const useLikes = ({ currentUserReactions, reactionCounts }: ReactionState) => {
    const reactionThumbsEmojiEnabled = useSelector(isFeatureEnabled('reaction-thumbs-up'));

    const isLiked = !isEmpty(currentUserReactions);

    const likedIcon = reactionThumbsEmojiEnabled ? mdiThumbUp : mdiHeart;
    const defaultIcon = reactionThumbsEmojiEnabled ? mdiThumbUpOutline : mdiHeartOutline;

    return {
        defaultIcon,
        likedIcon,
        isLiked,
        hasThumbsUp: reactionThumbsEmojiEnabled,
        likeCount: reactionCounts.total,
    };
};
